module.exports = jsyaml;


//////////////////
// WEBPACK FOOTER
// external "jsyaml"
// module id = 20
// module chunks = 1